import React from 'react';
import { Trophy, ArrowRight, Check, Award } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useAuth } from '../../context/AuthContext';

const SuccessStoriesPage = () => {
  const { login } = useAuth();

  const stories = [
    { company: 'Loja Fashion', industry: 'E-commerce', result: '+45% em vendas', quote: 'ChatAlfa transformou nosso atendimento e vendas.' },
    { company: 'Clínica Sorriso', industry: 'Saúde', result: '-60% em faltas', quote: 'Os lembretes automáticos reduziram drasticamente as faltas.' },
    { company: 'Imob Premium', industry: 'Imobiliário', result: '+80% em leads', quote: 'Qualificamos muito mais leads com menos esforço.' },
    { company: 'Salão Beleza', industry: 'Beleza', result: '+35% retorno', quote: 'Clientes voltam mais e indicam para amigos.' },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-28 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
          <div className="inline-flex items-center gap-2 bg-yellow-100 text-yellow-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
            <Trophy className="h-4 w-4" />Casos de Sucesso
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            <span className="text-yellow-500">Histórias</span> de sucesso
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-12">Veja como empresas estão transformando seus resultados com ChatAlfa.</p>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-8">
            {stories.map((story) => (
              <Card key={story.company} className="hover:shadow-xl transition-shadow">
                <CardContent className="p-8">
                  <div className="flex items-center gap-4 mb-4">
                    <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center">
                      <Award className="h-6 w-6 text-yellow-600" />
                    </div>
                    <div>
                      <h3 className="font-bold text-lg">{story.company}</h3>
                      <p className="text-sm text-gray-500">{story.industry}</p>
                    </div>
                  </div>
                  <p className="text-2xl font-bold text-[#3b82f6] mb-4">{story.result}</p>
                  <p className="text-gray-600 italic">"{story.quote}"</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        <div className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <Card className="bg-gradient-to-br from-[#3b82f6] to-[#1d4ed8] text-white">
              <CardContent className="py-12 text-center">
                <h2 className="text-2xl font-bold mb-4">Seja o próximo caso de sucesso</h2>
                <p className="text-blue-100 mb-6">Comece gratuitamente e veja resultados em dias</p>
                <Button onClick={login} variant="secondary" size="lg" className="bg-white text-[#3b82f6] hover:bg-gray-100">
                  Começar agora <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};
export default SuccessStoriesPage;
